import { forwardRef, useState } from 'react';
import { BaseTabBar } from './__internal__/';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabBar = /*#__PURE__*/forwardRef(function TabBar(props, ref) {
  const [focusedIndex, setFocusedIndex] = useState(props.selectedIndex < 0 ? 0 : props.selectedIndex);
  return /*#__PURE__*/_jsx(BaseTabBar, {
    ref: ref // added if consumer want to programmatically set focus from outside
    ,
    focusedIndex: focusedIndex,
    setFocusedIndex: setFocusedIndex,
    ...props
  });
});
//# sourceMappingURL=TabBar.js.map